import React from 'react'
import { Link } from 'react-router-dom'
import './white.css'
import cl from './img/cl.jpg'
import zp from './img/zp.jpg'

function Whitepaper() {
  return (
    <div className='paper'>
        <Link  to='/' style={{color:'blue', width:'100%'}} >
            <p>Go Back</p>
        </Link> 

        <div className='paperbod'>
            <h3>ZILL PROTOCOL WHITEPAPER</h3>
            <p>INTRODUCTION</p>

            <div className='mainp'>
                <p>
                Zill protocol is a type of blockchain network that is open to anyone to participate in and access without needing explicit approval or permission from a central authority. 
                </p>

                <p>
                    Zill protocol is a public, permissionless blockchain that is designed to offer high throughput with the ability to complete thousands of transactions per second. It seeks to solve the issue of    blockchain scalability and speed by employing sharding as a second-layer scaling solution. 
                </p>

                <p>The platform is home to many decentralized applications. Just like the days of Safemoon, babydogecoin and feg, the $Zill protocol is here to bring back this old days. We are not here for even 500k mc but we are going to hit millions of dollars mc. </p>

                <p>
                Zill protocol is the life changing token you have been waiting for. And we are not the regular memecoin you see everyday. We are here to bring liberation and freedom to all our investors. 
                </p>

                <p>If loop network did it then expect something great from us. Wait till you see our Chinese whales joining us. Step by step we will get everything done. As we have some good utilities that we are working on. </p>

                <p>Support us Stand by us and let’s moon together . We are the zillers.</p>


                <h3>TOKENOMICS</h3>

                <p>Zill protocol enables Web3 community members to participate in various activities such as approving proposals for protocol upgrades, staking for rewards, participating in burn auctions, and more.</p>

                <p>The $Zill token is the official token to be used for this project</p>

                <p>The project will be launching on BSC Blockchain The token would be available for presale and 3% of the supply will be distributed as airdrop.</p>

                <h3>EXECUTION STRATEGY</h3>

                <ul className='pul' >
                    <p>Phase 1</p>
                    <li>Building of the community: Our first stage of growth and progress is building a community of individuals that show interest in $Zillprotocol. </li>
                    <span>Join our community On Telegram </span>
                    <div>
                        <p>Telegram :
                            <a href='https://t.me/Zillprotocol' target='blank' >https://t.me/Zillprotocol </a>
                        </p>
                        <p>Twitter :
                            <a href='https://twitter.com/zillprotocol' target='blank' >https://twitter.com/zillprotocol </a>
                        </p>
                    </div>

                    <li> Inviting Influencers and Investors: The community also tend to welcome potential investors, whales and even based influencer. To facilitate and contribute to the growth and development of the $Zillprotocol. </li>

                    <li>Shilling Contest: As part of our method in facilitating the growth of Zill protocol, we would introduce shilling contests which in turn to expand the community.</li>

                    <li>Lauch: The team has announced that the fair launch of Zill protocol would be on the 15th of August, 2023. 7pm Utc.</li>

                    <img src={cl} alt='' />

                    <p>Phase 2</p>

                    <li>Launching of dApps Prior to launch, we will rigorously test our DApp to identify and fix any bugs and issues. We'll conduct a comprehensive audit of our smart contracts by trusted third-party experts to ensure security and reliability. We'll carefully choose the blockchain network that best suits our DApp's requirements in terms of scalability, cost, and user base. We'll leverage our existing community and actively engage new users through social media, forums, and online communities. </li>

                    <li>Creating of websites Along side with the launching of our dApp, we also intend to launch our official website. The website would contain all detailed information about our project and also information on how to participate heavily on the project. </li>

                    <li>Paying for Chinese callers for more promotions</li>

                    <p>Phase 3</p>
                    <small>In this phase, we would be giving out 3% of the supply as airdrop.</small>
                    <small>Then Dev to doxx and payments for marketing follows up.</small>

                    <p>Phase 4</p>

                    <small>We tend to be listing on several exchange platforms. Some of which includes:</small>
                    <li>Mexc listing </li>
                    <li>kucoin listing </li>
                </ul>

                <h3>EXECUTION SUMMARY</h3>
                <img src={zp} alt='' className='imgs'/>
            </div>
        </div>
    </div>
  )
}

export default Whitepaper